<div class="label-container">
    <cerrix-label [for]="name"><ng-content></ng-content></cerrix-label>
    @if (infoText) {
        <cerrix-instructions-icon
            class="input-instructions-icon"
            [instructionText]="infoText"
            [showText]="false"
        ></cerrix-instructions-icon>
    }
</div>
<app-cerrix-select
    [options]="options"
    [placeholder]="placeholder"
    [selectedValue]="selectedValue"
    [disabled]="disabled"
    (selectionChange)="selectionChange.emit($event)"
></app-cerrix-select>
